<template>
  <two-sides-modal
    v-model="isDialogOpen"
    title="Recibo de Pagos"
    subtitle="Recibo de Pagos"
    icon="mdi-archive-arrow-down-outline"
    height="auto"
  >
    <v-row>
      <v-col cols="12" md="12">
        <v-row class="mt-3 justify-space-between">
          <payment-history-notice />
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedMonth"
              :items="filteredMonths"
              item-text="month"
              item-value="number"
              hide-details
              small
              dense
              solo
              placeholder="Meses"
              class="ml-2"
              item-disabled="disabled"
            />
          </v-col>
          <v-col cols="12" md="4">
            <search-input v-model="search" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="12">
        <payment-receipt-table
          :items="items"
          :search="search"
          :downloading-id="downloadingId"
          @onPDFClick="openPDF"
        />
      </v-col>
    </v-row>
    <template slot="actions-append"> </template>
  </two-sides-modal>
</template>
<script>
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';
  import PaymentReceiptTable from './PaymentReceiptTable.vue';
  import SearchInput from '@/components/SearchInput.vue';
  import saveFile from '@/mixins/saveFile';
  import axios from '@/plugins/axios';
  import moment from 'moment';
  import accountStatusPaymentHistoryDate from '@/mixins/accountStatusPaymentHistoryDate';
  import PaymentHistoryNotice from '@/views/account_status/components/PaymentHistoryNotice.vue';

  export default {
    name: 'PaymentHistoryModal',
    components: {
      TwoSidesModal,
      SearchInput,
      PaymentReceiptTable,
      PaymentHistoryNotice,
    },
    mixins: [saveFile, accountStatusPaymentHistoryDate],
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      customerCode: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        months: [
          { month: 'Enero', number: '01' },
          { month: 'Febrero', number: '02' },
          { month: 'Marzo', number: '03' },
          { month: 'Abril', number: '04' },
          { month: 'Mayo', number: '05' },
          { month: 'Junio', number: '06' },
          { month: 'Julio', number: '07' },
          { month: 'Agosto', number: '08' },
          { month: 'Septiembre', number: '09' },
          { month: 'Octubre', number: '10' },
          { month: 'Noviembre', number: '11' },
          { month: 'Diciembre', number: '12' },
        ],
        items: [],
        search: '',
        selectedMonth: null,
        downloadingId: null,
      };
    },
    computed: {
      isDialogOpen: {
        set(newVal) {
          this.$emit('input', newVal);
        },
        get() {
          return this.value;
        },
      },
      currentYear() {
        return moment().year();
      },
      filteredMonths() {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();

        if (currentYear === this.minDateYear) {
          return this.months.filter(
            (m) =>
              m.number >= this.minDateMonthNumber && m.number <= currentMonth
          );
        }

        return this.months.filter((m) => m.number <= currentMonth);
      },
    },

    watch: {
      customerCode: {
        immediate: true,
        handler(val) {
          if (!val) return;

          this.selectedMonth = moment().format('MM');
          this.fetchPaymentReceipts();
        },
      },
      selectedMonth(newMonth) {
        if (newMonth) {
          this.fetchPaymentReceipts();
        }
      },
    },
    methods: {
      async fetchPaymentReceipts() {
        try {
          const dateMonth = `${this.currentYear}${this.selectedMonth}`;

          const response = await axios.get('/payments/reference-payment', {
            params: {
              customerCode: this.customerCode,
              dateMonth,
            },
          });

          this.items = response.data;
        } catch (error) {
          this.$toast.error('No se pudo obtener la información de Recibos');
        }
      },
      async openPDF(item) {
        this.downloadingId = item.IDPAG;
        try {
          const response = await axios.post(
            '/payments/pdf-receipt',
            {
              customerCode: this.customerCode,
              idPayment: item.IDPAG,
            },
            {
              responseType: 'blob',
            }
          );
          this.saveFileToDevice(response.data, 'recibo_pago', 'pdf');
        } catch (error) {
          this.$toast.error('No fue posible completar la descarga.');
        }
        this.downloadingId = null;
      },
    },
  };
</script>
